// config_names.js
const config_names = {
    projectName: "ResuRanker",
    projectName_genitive: "ResuRanker's",
    projectDomain: "ResuRanker.com",
    allow_skip_login_for_now: false,
    contactEmail: "contact@resuranker.com",
    jurisdiction: "Switzerland",
    operating_country: "Switzerland",
    effectiveDate: "March 1, 2025",
    domain: "https://resuranker.com",
  };
  
  export default config_names;